import { useSearchParams } from "react-router-dom";
import {
  ApplicationSubtype,
  AppPageContentWrapper,
  useViewDataControl,
  ViewAdditionalDocApp,
  ViewContentWrapper,
} from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import { buildFetchFileUrl } from "../../../../services/coreServicesCalls";
import React from "react";
import { createAppViewUrlWithServices } from "../../../../utils/applicationUrlUtils";
import ApplicationCorrespondenceList from "../common/correspondence/ApplicationCorrespondenceList";

const RegprofAdditionalDocView = ({ serviceFn }: { serviceFn: () => Promise<any> }) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const dossierNumber = searchParams.get("dossierNumber");

  useViewDataControl({
    viewType: ApplicationSubtype.REGPROF_ADDITIONAL_DOCUMENTS,
    viewId: id ? id : dossierNumber,
    serviceFn: serviceFn,
  });

  return (
    <AppPageContentWrapper>
      <Box sx={{ width: "100%" }}>
        <ViewContentWrapper viewType={ApplicationSubtype.REGPROF_ADDITIONAL_DOCUMENTS} viewId={id ? id : dossierNumber}>
          <ViewAdditionalDocApp
            buildFetchFileUrlFn={buildFetchFileUrl}
            buildViewApplicationUrlFn={createAppViewUrlWithServices}
            additionalAppInfoComponent={<ApplicationCorrespondenceList applicationId={id} />}
          />
        </ViewContentWrapper>
      </Box>
    </AppPageContentWrapper>
  );
};
export default RegprofAdditionalDocView;
